import { slugOf } from '~utils/functions/slugOf'

const getUserLink = ({ userId, firstName, lastName }) => {
  const username = [firstName, lastName].join(' ')
  return `/user/${userId}/${slugOf(username)}`
}

export { getUserLink }
